import React from "react";
import "./error-indicator.scss";

const ErrorIndicator = () => {
    return <div>Упс... что то пошло не так</div>;
};

export default ErrorIndicator;
